<template>
	<div class="feedback-content" v-show="finish">
		<div class="ss-container">
			<div class="feedback-title">调查问卷</div>
			<div class="feedback-input-box">
				<div v-for="(item, index) in formELe" :key="item.id">
					<div class="feedback-input-title">
						Q{{(index + 1) + '、' +item.title}}
						<span class="color-error" v-if="item.isAnswer">*</span>
					</div>
					<div class="radio-box" v-if="item.type === 1 || item.type === 2">
						<label v-for="it in item.options" :key="it.id">
							<input :type="item.type === 1 ? 'radio' : 'checkbox'" @change="inputChange(it.id, item.id, item.type)" :value="it.id" :name="'attr_' + item.id" />{{it.name}}
						</label>
					</div>
					<input class="feedback-input" :ref="'qaq' + item.id" v-else @input="inputChange($event, item.id, 3)" :placeholder="'请输入' + item.title" />
				</div>
				<button class="submit-btn" :class="[disabled_ ? 'btn-disabled' : 'btn-primary']" @click="questionnaire">提交</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 题目类型type：1为单选，2为多选，3为问答，理论上不会有其他值，如果出现其他值，都按3处理。
				formELe: [],
				formData: {},
				finish: false
			}
		},
		computed: {
			disabled_() {
				let isAnswerArr = this.formELe.filter(o => o.isAnswer).map(o => 'attr_' + o.id);
				let disabled = false;
				for(var i in isAnswerArr){
					let item = this.formData[isAnswerArr[i]];
					if(!(this.$typeof(item) === 'Array' ? item.length : item)){
						disabled = true;
						break;
					}
				}
				return disabled;
			}
		},
		created() {
			this.questionnaireForm();
		},
		methods: {
			inputChange(e, field, type = 1){
				let attrVal = this.formData['attr_' + field];
				if(type === 2){
					!attrVal && (attrVal = []);
					let index = attrVal.indexOf(e);
					index !== -1 ? attrVal.splice(index, 1) : attrVal.push(e);
				}else{
					attrVal = type === 3 ? this.$refs['qaq' + field][0].value : (type === 1 ? e : '');
				}
				this.$set(this.formData, ('attr_' + field), attrVal);
			},
			async questionnaireForm() {
				let res = await this.$http('questionnaireForm');
				if(res.code === 1){
					this.finish = true;
					this.formELe = res.data || [];
				}
			},
			async questionnaire() {
				if(this.disabled_) return this.$toast('有必填项未做输入或者选择');
				let params = this.$deepClone(this.formData);
				for(var i in params){
					if(this.$typeof(params[i]) === 'Array'){
						params[i] = params[i].join(',');
					}
				}
				params.questionnaireId = this.formELe[0].questionnaireId;
				let res = await this.$http('questionnaire', params);
				if(res.code === 1){
					this.formData = {}
					let formELe = this.$deepClone(this.formELe);
					this.formELe = [];
					this.$nextTick(() => {
						setTimeout(() => {
							this.formELe = formELe;
						}, 10)
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/feedback.scss';
</style>
